import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
export const SelectCard = ({ title, value, onChange, options, noOptionsLabel, selectLabel, selectLabelId, disabled = false, }) => {
    const handleChange = (e) => {
        onChange(e.target.value);
    };
    return (React.createElement(Box, { p: 2, bgcolor: themeColors.surface.secondary },
        React.createElement(Grid, { container: true, spacing: 2, alignItems: 'center' },
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(Typography, { variant: 'subtitle1' }, title)),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { disabled: disabled, fullWidth: true },
                    React.createElement(InputLabel, { id: selectLabelId }, selectLabel),
                    React.createElement(Select, { value: value, onChange: handleChange, label: selectLabel, labelId: selectLabelId }, (options === null || options === void 0 ? void 0 : options.length) ? (options.map((option) => (React.createElement(MenuItem, { key: option.value, value: option.value }, option.label)))) : (React.createElement(MenuItem, { disabled: true }, noOptionsLabel))))))));
};
